module.exports = __webpack_public_path__ + "img/thumb_04.7620d657.jpg";